import { LINKEDIN_CAPTION_LIMIT, LINKEDIN_RENDITIONS, linkedinGridRendition } from '../../../../lib/linkedin-post-preview';
import { postAuthorName, postLinkDomain, postLinkUrl, postMediaGrid } from '../../../../lib/social-post-look-parts';
import {
  PostAvatar,
  PostCaption,
  PostGrid,
  PostSingleMedia,
  PostTiming,
  useMediaLabel,
  type SocialPostLookProps,
} from './SocialPostLookParts';
import styles from './LinkedinPostPreview.module.css';

export function LinkedinPostPreview({ card, onOpenMedia, onToggleCaption, onOpenLink }: SocialPostLookProps) {
  const label = useMediaLabel(card);
  const grid = postMediaGrid(card);
  const linkUrl = grid.kind === 'none' ? postLinkUrl(card.link) : undefined;
  return (
    <>
      <header className={styles.header}>
        <PostAvatar card={card} name={postAuthorName(card)} size={30} logoSize={16} />
        <div className={styles.names}>
          <span className={styles.name} data-testid="linkedin-name">
            <bdi>{postAuthorName(card)}</bdi>
          </span>
          <span className={styles.when} data-testid="linkedin-when">
            <PostTiming card={card} />
          </span>
        </div>
      </header>
      {card.caption && (
        <PostCaption
          caption={card.caption}
          className={styles.caption}
          testId="linkedin-caption"
          cut={{ limit: LINKEDIN_CAPTION_LIMIT }}
          onToggle={onToggleCaption}
        />
      )}
      {grid.kind === 'single' && (
        <PostSingleMedia
          key={grid.tile.url}
          media={grid.tile}
          label={label(grid.tile, 0)}
          rendition={LINKEDIN_RENDITIONS.single}
          className={`${styles.media} ${styles.single}`}
          testId="linkedin-media"
          onOpen={() => onOpenMedia(grid.tile, 0)}
        />
      )}
      {grid.kind === 'grid' && (
        <PostGrid grid={grid} label={label} rendition={linkedinGridRendition} className={styles.media} testId="linkedin-media" onOpen={onOpenMedia} />
      )}
      {linkUrl && (
        <a
          className={styles.linkCard}
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
          dir="ltr"
          onClick={onOpenLink}
          data-testid="linkedin-link-card"
        >
          <span className={styles.linkTitle}>{linkUrl}</span>
          <span className={styles.domain} data-testid="linkedin-link-domain">
            {postLinkDomain(linkUrl, { keepWww: true })}
          </span>
        </a>
      )}
    </>
  );
}
